import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ArrowRight } from "@phosphor-icons/react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section
      id="journal"
      data-testid="journal-section"
      className="relative py-20 md:py-32 px-5 md:px-10 lg:px-16"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div>
          <p className="section-num mb-3">07 — The Journal</p>
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter leading-[0.9]">
            Field<br />notes.
          </h2>
        </div>
        <p className="max-w-md text-base">
          Trade tips, colour stories and Melbourne-specific guides — written by the crew, not a content team.
        </p>
      </div>

      <div className="grid grid-cols-12 gap-4 md:gap-6">
        {posts.map((p, i) => (
          <button
            key={p.id}
            data-testid={`blog-${p.slug}`}
            onClick={() => setActive(p)}
            className={`group text-left border-2 border-[#111] overflow-hidden bg-[#F2F2EF] hover:shadow-brut transition-all hover:-translate-y-1 ${
              i === 0 ? "col-span-12 md:col-span-6" : "col-span-12 md:col-span-3"
            }`}
          >
              <div className="aspect-[16/10] overflow-hidden border-b-2 border-[#111]">
                <img src={p.cover_image} alt={`${p.title} — Melbourne painting guide`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" width="1200" height="750" onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1400&q=80"; }} />
              </div>
            <div className="p-5 md:p-6">
              <div className="flex flex-wrap gap-1 mb-3">
                {p.tags?.map((t) => (
                  <span key={t} className="chip text-[10px] py-1 px-2">{t}</span>
                ))}
              </div>
              <h3 className="font-display text-xl md:text-2xl uppercase tracking-tight leading-tight">{p.title}</h3>
              <p className="mt-2 text-sm text-[#444]">{p.excerpt}</p>
              <div className="mt-4 flex items-center gap-2 text-xs uppercase tracking-widest text-[#D85C3A] font-bold">
                Read piece <ArrowRight size={16} weight="bold" />
              </div>
            </div>
          </button>
        ))}
      </div>

      {active && (
        <div
          data-testid="blog-modal"
          className="fixed inset-0 z-50 bg-black/80 flex items-start md:items-center justify-center p-4 overflow-auto slide-up"
          onClick={() => setActive(null)}
        >
          <div
            className="bg-[#F2F2EF] border-2 border-[#111] max-w-3xl w-full my-10 shadow-brut"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="aspect-[16/9] overflow-hidden border-b-2 border-[#111]">
              <img src={active.cover_image} alt={active.title} className="w-full h-full object-cover" onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1400&q=80"; }} />
            </div>
            <div className="p-6 md:p-10">
              <h3 className="font-display text-3xl md:text-5xl uppercase tracking-tighter leading-[0.95]">{active.title}</h3>
              <div className="mt-4 text-base md:text-lg leading-relaxed prose-tmp">
                {(active.format === "markdown" || /^#\s|\n##\s/.test(active.content)) ? (
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>{active.content}</ReactMarkdown>
                ) : (
                  <p>{active.content}</p>
                )}
              </div>
              <button
                data-testid="close-blog-modal"
                onClick={() => setActive(null)}
                className="btn-outline-brut mt-6"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
